import {Component, enableProdMode, inject} from "@angular/core";
import {environment} from "@shared/environments";
import {bootstrapApplication} from "@angular/platform-browser";
import {config} from "../config/config";
import {RouterOutlet} from "@angular/router";
import {MainPageLoaderComponent, ServiceUnavailableComponent} from "@shared/ui";
import {NgIf, registerLocaleData} from "@angular/common";
import {AuthGuard} from "@shared/route-guards";
import {AuthService} from "@shared/api";
import localeRu from "@angular/common/locales/ru";
import {enableMocking} from "../mocks/enable-mocking";

if (environment.production) {
    enableProdMode();
}

@Component({
    selector: "app-root",
    template: `
        @if (serviceUnavailableMode) {
            <app-service-unavailable></app-service-unavailable>
        } @else if (authGuard.loader()) {
            <app-main-page-loader></app-main-page-loader>
        } @else {
            <router-outlet></router-outlet>
        }
    `,
    imports: [RouterOutlet, MainPageLoaderComponent, ServiceUnavailableComponent]
})
export class AppComponent {
    authGuard = inject(AuthGuard);
    private authService = inject(AuthService);

    serviceUnavailableMode = false;

    constructor() {
        const authService = this.authService;

        registerLocaleData(localeRu, "ru");
        if (!this.serviceUnavailableMode)
            authService.runInitialLoginSequence().catch(error => console.error("Ошибка инициализации аутентификации", error));
    }
}

async function resolveRealm(): Promise<string> {
    try {
        const response = await fetch("/config/app.config.json");
        const runtimeConfig = await response.json();
        return runtimeConfig.realm ?? environment.realm;
    } catch (error) {
        console.error("Не удалось загрузить runtime-конфиг для определения realm", error);
        return environment.realm;
    }
}

resolveRealm()
    .then(realm => enableMocking(realm))
    .then(() => {
        bootstrapApplication(AppComponent, config)
            .catch(err => console.error(err));
    });
